/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type RailContainer_photoQuery = {
    readonly firmId: string | null;
    readonly projectId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"FirmDetails_photoQuery" | "PhotoDetails_photoQuery">;
    readonly " $refType": "RailContainer_photoQuery";
};
export type RailContainer_photoQuery$data = RailContainer_photoQuery;
export type RailContainer_photoQuery$key = {
    readonly " $data"?: RailContainer_photoQuery$data;
    readonly " $fragmentRefs": FragmentRefs<"RailContainer_photoQuery">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "RailContainer_photoQuery",
  "type": "TradePhotosQueryOutput",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firmId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "projectId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "FirmDetails_photoQuery",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PhotoDetails_photoQuery",
      "args": null
    }
  ]
};
(node as any).hash = '034375c1dc665821b069bd2c9f647dd1';
export default node;
